import { useQuery } from '../../../../ReactQuery';
import { get } from '../../../../redux/api';
import type { ListInstallationsResponse } from '../../../../../shared/types/routes/vcs/githubApp';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

const fetchGitHubAppInstallations = (app: VcsApp) =>
  get<ListInstallationsResponse>(`/api/vcs/github-apps/${app}/installations`);

export const getGitHubAppInstallationsQueryKey = (app: VcsApp) =>
  ['vcs', 'github-apps', app, 'installations'] as const;

/**
 * Lists every GitHub account the org has connected for `app` (one per installation).
 * The import flow uses this to populate the account menu (switching accounts, and installing another).
 * Pass `enabled: false` before the app is installed to hold the request until there's a connection.
 */
export function useGitHubAppInstallations(app: VcsApp, { enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: getGitHubAppInstallationsQueryKey(app),
    queryFn: () => fetchGitHubAppInstallations(app),
    enabled,
  });
}
